import { useState, useEffect } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api } from '../services/api';
import { apiError } from '../crm/context/CRMAuthContext';

const Settings = ({permissions}) => {
  const [loading,setLoading]=useState(true),[error,setError]=useState(''),[saving,setSaving]=useState(false);
  const canEdit=!permissions||permissions.includes('manager.settings.manage');
  const [settings, setSettings] = useState({
    brokerName: "E1 Broker Pro",
    environment: "Real2",
    newsMode: false,
    marginCallLevel: 70,
    stopOutLevel: 30,
    defaultLeverage: 100,
    defaultCommission: 0
  });

  useEffect(()=>{api.get('/trading-settings').then(({data})=>setSettings({brokerName:data.broker_name,environment:data.environment||'Real',newsMode:data.news_mode||false,marginCallLevel:data.margin_call_level,stopOutLevel:data.stop_out_level,defaultLeverage:data.forex_base_leverage,defaultCommission:data.commission_size})).catch(e=>setError(apiError(e))).finally(()=>setLoading(false));},[]);
  const handleSave = async () => {
    setSaving(true);setError('');
    try{await api.put('/trading-settings',{broker_name:settings.brokerName,environment:settings.environment,news_mode:settings.newsMode,margin_call_level:settings.marginCallLevel,stop_out_level:settings.stopOutLevel,forex_base_leverage:settings.defaultLeverage,commission_size:settings.defaultCommission});toast.success('Ayarlar kaydedildi.');}catch(e){setError(apiError(e));}finally{setSaving(false);}
  };

  return (
    <div className="p-6" data-testid="manager-settings-page">
      <h1 className="sirix-page-title" style={{ padding: 0, marginBottom: 24 }}>SETTINGS</h1>
      
      {error&&<p className="crm-error" role="alert" data-testid="settings-error">{error}</p>}
      {loading&&<p data-testid="settings-loading">Yükleniyor…</p>}
      <fieldset disabled={loading||saving||!canEdit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* General Settings */}
        <div className="sirix-card">
          <div className="sirix-card-header">
            <h3 className="sirix-card-title">General Settings</h3>
          </div>
          <div className="sirix-card-body space-y-4">
            <div className="sirix-form-group">
              <label className="sirix-form-label">Broker Name</label>
              <input 
                type="text" 
                className="sirix-form-input"
                value={settings.brokerName}
                data-testid="settings-broker-name"
                onChange={(e) => setSettings({ ...settings, brokerName: e.target.value })}
              />
            </div>
            <div className="sirix-form-group">
              <label className="sirix-form-label">Environment</label>
              <select 
                className="sirix-form-select"
                value={settings.environment}
                data-testid="settings-environment"
                onChange={(e) => setSettings({ ...settings, environment: e.target.value })}
              >
                <option>Real</option>
                <option>Real2</option>
                <option>Demo</option>
              </select>
            </div>
            <div className="sirix-form-group">
              <label className="sirix-checkbox">
                <input 
                  type="checkbox"
                  checked={settings.newsMode}
                  data-testid="settings-news-mode"
                  onChange={(e) => setSettings({ ...settings, newsMode: e.target.checked })}
                />
                <span>News Mode</span>
              </label>
            </div>
          </div>
        </div>

        {/* Trading Settings */}
        <div className="sirix-card">
          <div className="sirix-card-header">
            <h3 className="sirix-card-title">Default Trading Settings</h3>
          </div>
          <div className="sirix-card-body space-y-4">
            <div className="sirix-form-group">
              <label className="sirix-form-label">Margin Call Level (%)</label>
              <input 
                type="number" 
                className="sirix-form-input"
                value={settings.marginCallLevel}
                data-testid="settings-margin-call"
                onChange={(e) => setSettings({ ...settings, marginCallLevel: parseFloat(e.target.value) })}
              />
            </div>
            <div className="sirix-form-group">
              <label className="sirix-form-label">Stop Out Level (%)</label>
              <input 
                type="number" 
                className="sirix-form-input"
                value={settings.stopOutLevel}
                data-testid="settings-stop-out"
                onChange={(e) => setSettings({ ...settings, stopOutLevel: parseFloat(e.target.value) })}
              />
            </div>
            <div className="sirix-form-group">
              <label className="sirix-form-label">Default Leverage</label>
              <select 
                className="sirix-form-select"
                value={settings.defaultLeverage}
                data-testid="settings-leverage"
                onChange={(e) => setSettings({ ...settings, defaultLeverage: parseInt(e.target.value) })}
              >
                <option value={50}>1:50</option>
                <option value={100}>1:100</option>
                <option value={200}>1:200</option>
                <option value={500}>1:500</option>
              </select>
            </div>
            <div className="sirix-form-group">
              <label className="sirix-form-label">Default Commission (%)</label>
              <input 
                type="number" 
                className="sirix-form-input"
                value={settings.defaultCommission}
                data-testid="settings-commission"
                onChange={(e) => setSettings({ ...settings, defaultCommission: parseFloat(e.target.value) })}
                step="0.01"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <div className="mt-6">
        <button className="sirix-btn sirix-btn-primary" data-testid="settings-save" disabled={loading||saving||!canEdit} onClick={handleSave}>
          <Save size={14} />
          Save Settings
        </button>
      </div>
    </div>
  );
};

export default Settings;
